import { useContext } from "react";
import { ThemeContext } from "./ThemeProvider";

/**
 * Hook exposing the theme preference, the resolved effective theme, and a
 * setter. Must be used inside <ThemeProvider> — throws otherwise so misuse
 * surfaces immediately in dev.
 */
export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error("useTheme must be used inside <ThemeProvider>");
  }
  return ctx;
}
